import * as React from "react"

import { Container, Text } from "./Styles"

const None = ({ text }: { text: string }): JSX.Element => {
  return (
    <Container data-testid="catalog-none">
      <Text>{text}</Text>
    </Container>
  )
}

export default None
